import { GlEmptyState, GlLoadingIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import emptySearchSvg from '@gitlab/svgs/dist/illustrations/empty-state/empty-search-md.svg';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import ErrorsAlert from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/errors_alert.vue?vue3';
import { fetchPolicies } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import { TYPENAME_PROJECT, TYPENAME_GROUP } from '~/graphql_shared/constants';
import { convertToGraphQLId } from '~/graphql_shared/utils';
import { TYPENAME_AI_CATALOG_ITEM } from 'ee/graphql_shared/constants';
import { AI_CATALOG_TYPE_FOUNDATIONAL_AGENT } from '../constants';
import { resolveVersion, transformFoundationalAgentToItem } from '../utils';
import { getRegistryItem } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/item_type_registry.js?vue3';
import { breadcrumbState, itemKeyFromRoute } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/router/breadcrumb_state.js?vue3';
export default {
    name: 'AiCatalogItem',
    components: {
        ErrorsAlert,
        GlEmptyState,
        GlLoadingIcon
    },
    inject: {
        isGlobalNamespace: {},
        isGroupNamespace: {
            default: false
        },
        projectId: {
            default: null
        },
        rootGroupId: {
            default: null
        },
        groupId: {
            default: null
        }
    },
    props: {
        itemType: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            aiCatalogItem: {},
            activeVersionKey: null,
            errors: []
        };
    },
    apollo: {
        aiCatalogItem: {
            query () {
                return this.itemRegistry.queries.item;
            },
            variables () {
                if (this.itemType === AI_CATALOG_TYPE_FOUNDATIONAL_AGENT) {
                    return {
                        reference: this.$route.params.reference
                    };
                }
                const hasGroup = Boolean(this.projectId ? this.rootGroupId : this.groupId);
                const groupId = this.projectId ? this.rootGroupId : this.groupId;
                return {
                    id: convertToGraphQLId(TYPENAME_AI_CATALOG_ITEM, this.$route.params.id),
                    showSoftDeleted: !this.isGlobalNamespace,
                    hasProject: Boolean(this.projectId),
                    projectId: convertToGraphQLId(TYPENAME_PROJECT, this.projectId || '0'),
                    hasGroup,
                    groupId: convertToGraphQLId(TYPENAME_GROUP, groupId || '0')
                };
            },
            // fetchPolicy needed to refresh item after updating triggers
            fetchPolicy: fetchPolicies.CACHE_AND_NETWORK,
            update (data) {
                if (this.itemType === AI_CATALOG_TYPE_FOUNDATIONAL_AGENT) {
                    const foundationalAgent = data.aiFoundationalChatAgent;
                    if (!foundationalAgent) return {};
                    return this.transformFoundationalAgentToItem(data.aiFoundationalChatAgent);
                }
                const item = data?.aiCatalogItem || {};
                if (!this.itemRegistry.acceptedTypes.includes(item.itemType)) {
                    return {};
                }
                return item;
            },
            result () {
                this.updateTitle(this.aiCatalogItem.name);
            },
            error (error) {
                this.errors = [
                    this.itemRegistry.errorMessage
                ];
                Sentry.captureException(error);
            }
        }
    },
    computed: {
        itemRegistry () {
            return getRegistryItem(this.itemType);
        },
        isLoading () {
            return this.$apollo.queries.aiCatalogItem.loading;
        },
        isItemNotFound () {
            return this.aiCatalogItem && Object.keys(this.aiCatalogItem).length === 0;
        },
        isEnabled () {
            return this.groupId ? Boolean(this.aiCatalogItem?.configurationForGroup?.enabled) : Boolean(this.aiCatalogItem?.configurationForProject?.enabled);
        },
        resolvedVersion () {
            return resolveVersion(this.aiCatalogItem, {
                isGlobalNamespace: this.isGlobalNamespace,
                isGroupNamespace: this.isGroupNamespace
            });
        },
        isUpdateAvailable () {
            const latestVersion = this.aiCatalogItem.latestVersion?.versionName;
            const pinnedVersion = this.resolvedVersion.versionName;
            // The backend always bumps *up*, so we don't need a complex comparison
            return this.isEnabled && latestVersion && latestVersion !== pinnedVersion;
        },
        version () {
            return {
                isUpdateAvailable: this.isUpdateAvailable,
                activeVersionKey: this.activeVersionKey ?? this.resolvedVersion.key,
                baseVersionKey: this.resolvedVersion.key,
                setActiveVersionKey: (selectedKey)=>{
                    this.activeVersionKey = selectedKey;
                }
            };
        }
    },
    beforeDestroy () {
        breadcrumbState.clearName();
    },
    methods: {
        updateTitle (name) {
            if (!this.baseTitle) {
                const { pageTitle } = this.itemRegistry;
                this.baseTitle = document.title.includes(pageTitle) ? document.title : `${pageTitle} · ${document.title}`;
            }
            if (!name) return;
            document.title = `${name} · ${this.baseTitle}`;
            breadcrumbState.setName(itemKeyFromRoute(this.$route), name);
        },
        transformFoundationalAgentToItem
    },
    emptySearchSvg
};
